const NAMESPACE = 'Core'
export const PROGRESS = NAMESPACE + '/Progress'

export function progressReducer(state = {}, action) {
    switch (action.type) {
        case PROGRESS:
            if (action.progress == 1) {
                var nextState = {...state}
                delete nextState[action.name]
                return nextState
            }
            return {...state, [action.name]: action.progress}
        default:
            return state
    }
}

// middleware

export function progressMiddleware({dispatch}) {
    return (next) => (action) => {
        if (action.worker) {
            const worker = next(action.worker)

            worker.addEventListener('message', function(event) {
                if (event.data.error) {
                    dispatch({
                        type: PROGRESS,
                        name: action.name,
                        progress: 1
                    })
                } else if (event.data.progress) {
                    dispatch({
                        type: PROGRESS,
                        name: action.name,
                        progress: event.data.progress
                    })
                }
            })
            worker.addEventListener('error', function(event) {          
                dispatch({
                    type: PROGRESS,
                    name: action.name,
                    progress: 1
                })
            })

            return worker
        }
        return next(action)
    }
}

// action

export default function progress(worker, name) {
    return {worker, name}
}


// WEBPACK FOOTER //
// ./lib/core/redux/progress.js